import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** Error to render if getting config fails. */
export const AppConfigError = ({ error }) => (_jsxs("div", { style: { border: 'red 1px outset', width: '100%' }, children: [_jsx("h1", { children: "Error connecting to environment" }), _jsx("p", { children: error.message })] }));
